import PendingActionsIcon from "@mui/icons-material/PendingActions"
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined"
import AssignmentLateOutlinedIcon from "@mui/icons-material/AssignmentLateOutlined"
import DownloadingIcon from "@mui/icons-material/Downloading"
import UnsubscribeOutlinedIcon from "@mui/icons-material/UnsubscribeOutlined"
import ReportGmailerrorredOutlinedIcon from "@mui/icons-material/ReportGmailerrorredOutlined"

export const config = [
  {
    code: "DELEGATION-MISSING",
    title: "Habilitación en proceso: Delegación aún no registrada",
    color: "grey",
    icon: (
      <AssignmentLateOutlinedIcon
        style={{
          cursor: "pointer",
        }}
      />
    ),
  },
  {
    code: "ACTIVE-LOAD-FAIL-NO-AUTH",
    title: "Servicio activo: Recuperación fallida CUIT sin autorización",
    color: "",
    icon: (
      <ReportGmailerrorredOutlinedIcon
        style={{
          cursor: "pointer",
        }}
      />
    ),
  },
  {
    code: "WAITING-DELEGATION",
    title: "Habilitación en proceso: Delegación en espera",
    color: "green",
    icon: (
      <PendingActionsIcon
        style={{
          cursor: "pointer",
        }}
      />
    ),
  },
  {
    code: "DELEGATION-ACCEPTED",
    title: "Habilitación en proceso: Delegación aceptada",
    color: "green",
    icon: (
      <AssignmentTurnedInOutlinedIcon
        style={{
          cursor: "pointer",
        }}
      />
    ),
  },
  {
    code: "DISABLED",
    title: "Servicio no activo: deshabilitación",
    color: "red",
    icon: (
      <UnsubscribeOutlinedIcon
        style={{
          cursor: "pointer",
        }}
      />
    ),
  },
  {
    code: "DELEGATION-CANCEL-IN-PROGRESS",
    title: "Servicio No Activo: Baja Delegación en Proceso",
    color: null,
    icon: (
      <DownloadingIcon
        style={{
          cursor: "pointer",
        }}
      />
    ),
  },
]
